import React, { useEffect, useState, useMemo } from 'react';
import {
  viewPermissionRefs,
  findPermissionRef,
} from '../../../core/components/UserGroupPermissions';
import TodaysTasks from './TodaysTasks';
import TodaysTasksNew from './TodaysTasksNew';
import Tasks from './Tasks';
import { getLastFourHoursTasks, getTodaysTaskCompletions } from '../actions';
import Tabs from '../../../core/components/Tabs';
import { useIntl } from 'react-intl';
import CompletionLogs from './CompletionLogs';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserGroup } from '../../../store/authReducer';
import { selectLastFourHoursTasks } from '../reducer';
import { getTodaysTaskCompletionsDefaultQuery } from '../helpers';
import { selectSite } from '../../../store/authReducer';
import Loader from '../../../core/components/Loader';

const TasksViews = () => {
  const [tabType, setTabType] = useState('todaysTasks');
  const intl = useIntl();
  const dispatch = useDispatch();
  const primarySite = useSelector(selectSite);
  const lastFourHoursTasks = useSelector(selectLastFourHoursTasks);
  const permissions = useSelector(selectUserGroup);

  useEffect(() => {
    dispatch(getLastFourHoursTasks());
    dispatch(getTodaysTaskCompletions(getTodaysTaskCompletionsDefaultQuery(true)));
  }, []);
  useEffect(() => {
    const hasTodaysTasksNewPermission = permissions.permissions.some(
      (permission) => permission.ref === viewPermissionRefs.todays_tasks_new
    );
    if (hasTodaysTasksNewPermission) {
      setTabType('todaysTasksNew');
    } else {
      setTabType('todaysTasks');
    }
  }, [permissions]);

  // Check if user has todays_tasks_new permission (today_task_wip.view)
  const hasTodaysTasksWipPermission = useMemo(() => {
    if (!permissions?.permissions) return false;
    return Boolean(findPermissionRef(permissions.permissions, viewPermissionRefs.todays_tasks_new));
  }, [permissions]);

  // Build tabComponents array, conditionally including todaysTasksNew tab based on permission
  const tabComponents = useMemo(() => {
    const baseTabs = [
      {
        component: (
          <div className="col-sm-12">
            <TodaysTasks />
          </div>
        ),
        title: intl.formatMessage({ id: 'todaysTasks' }),
        type: 'todaysTasks',
        permissionKey: viewPermissionRefs.task,
      },
      {
        component: <Tasks />,
        title: intl.formatMessage({ id: 'All tasks' }),
        type: 'tasks',
        permissionKey: viewPermissionRefs.task,
      },
      {
        component: (
          <div className="col-sm-12">
            <CompletionLogs />
          </div>
        ),
        title: intl.formatMessage({ id: 'completedTasks' }),
        type: 'completedTasks',
        permissionKey: viewPermissionRefs.view_logs,
      },
    ];

    // If user has todays_tasks_new permission, add the todaysTasksNew tab and remove the todaysTasks tab
    // set tabType to todaysTasksNew
    if (hasTodaysTasksWipPermission) {
      setTabType('todaysTasksNew');
      baseTabs.splice(0, 1, {
        component: (
          <div>
            <TodaysTasksNew primarySite={primarySite} lastFourHoursTasks={lastFourHoursTasks} />
          </div>
        ),
        title: intl.formatMessage({ id: 'todaysTasks' }),
        type: 'todaysTasksNew',
        permissionKey: viewPermissionRefs.task,
      });
    }

    return baseTabs;
  }, [hasTodaysTasksWipPermission, intl, primarySite, lastFourHoursTasks]);

  const getTabsProps = () => ({
    tabs: tabComponents,
    onClick: setTabType,
    selectedType: tabType,
  });
  const visibleComponent = tabComponents.find((t) => t.type === tabType);

  return permissions ? (
    <div className="container-fluid">
      <Tabs {...getTabsProps()} />
      <div className="detergent-tab-container">
        <div>{visibleComponent?.component || <Loader />}</div>
      </div>
    </div>
  ) : (
    <Loader />
  );
};

export default TasksViews;
